module.exports = __webpack_public_path__ + "img/1-3.49659a09.png";